// extracted by mini-css-extract-plugin
export default {"buttonGroup":"ReviewSectionsModal__buttonGroup","blockBtn":"ReviewSectionsModal__blockBtn","heading":"ReviewSectionsModal__heading","SectionList":"ReviewSectionsModal__SectionList"};